















































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteHospitaisStore from '@/components/Suporte/Store/SuporteHospitaisStore'
import HOSPITAL_FLAGS from '@/utils/hospitalFlags'


@Component
export default class ComponentModalEditarSuporteHospital extends Vue {
  $refs!: {
    formEditarHospital: any,
    imageUpload: any,
    dtPicker1: any,
    hospitalTabs: any,
  }

  formEditarHospitalRules: any = {
    valid: true,
    hisTipo: [(v: any) => !!v || 'Campo obrigatório'],
  }

  tab: string = 'contexto-hospital'

  eligibilityPeriods = [
    { value: 12, description: '12h' }, { value: 24, description: '24h' }, { value: 36, description: '36h' },
    { value: 48, description: '48h' }, { value: 72, description: '72h' }, { value: 84, description: '84h' },
    { value: 96, description: '96h' },
  ]

  localFlags: Record<string, boolean> = {}
  dirtyKeys: string[] = []

  get getSuporteHospitaisStore() {
    return getModule(SuporteHospitaisStore, this.$store)
  }

  loadSaveOrUpdateHospital: boolean = false
  get loadingSaveOrUpdateHospital() { return this.loadSaveOrUpdateHospital }
  set loadingSaveOrUpdateHospital(value: boolean) { this.loadSaveOrUpdateHospital = value }

  get showModalEditarHospital() { return this.getSuporteHospitaisStore.modal.editarHospital }
  set showModalEditarHospital(value: boolean) { this.getSuporteHospitaisStore.setModal({ name: 'editarHospital', value }) }

  async saveOrUpdateHospital() {
    this.loadingSaveOrUpdateHospital = true

    if (this.$refs.formEditarHospital.validate()) {
      const payload: Record<string, any> = { ...this.getSuporteHospitaisStore.hospitalConfigFlag as any }

      Object.entries(this.localFlags).forEach(([key, value]) => {
        payload[key] = value
      })

      const response = await this.getSuporteHospitaisStore.updateConfiguracaoHospital(payload)

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Hospital alterado com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        await this.getSuporteHospitaisStore.getHospitalAll()
        this.showModalEditarHospital = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao alterar o hospital ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateHospital = false
  }

  onFlagToggle(key: string, value: boolean) {
    this.$set(this.localFlags, key, value)
    if (!this.dirtyKeys.includes(key)) {
      this.dirtyKeys.push(key)
    }
  }

  get textFieldProps() {
    return {
      'prepend-icon': 'las la-calendar-alt',
      class: 'edit-hospital-text-grid__input',
    }
  }

  get datePickerProps() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
    }
  }

  get timePickerProps() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      format: '24hr',
    }
  }

  @Watch('showModalEditarHospital')
  onChangeShowModalEditarHospital(value: boolean) {
    if (value) {
      this.$refs.hospitalTabs.callSlider()
      this.localFlags = {}
      this.dirtyKeys = []
      this.flags.forEach(f => {
        this.$set(this.localFlags, f.key, !!(this.getSuporteHospitaisStore.hospitalConfigFlag as any)[f.key])
      })
    }

    if (!value) {
      this.getSuporteHospitaisStore.clearHospitalConfigFlag()
      this.$refs.formEditarHospital.resetValidation()
      this.$refs.formEditarHospital.reset()
      this.getSuporteHospitaisStore.setMode({ mode: 'CREATE' })
      this.tab = 'contexto-hospital'
      this.localFlags = {}
      this.dirtyKeys = []
    }
  }

  get flags() {
    return HOSPITAL_FLAGS
  }
}
